export const FAVOURITES_SUMMARY_FETCHED_EVENT = 'FAVOURITES_SUMMARY_FETCHED';
export const FAVOURITE_REMOVED_EVENT = 'FAVOURITE_REMOVED';
export const FAVOURITE_ADDED_EVENT = 'FAVOURITE_ADDED';
export const FAVOURITES_FOLDER_SELECTED_EVENT = 'FAVOURITES_FOLDER_SELECTED';
export const FAVOURITES_FOLDER_NOT_SELECTED_EVENT = 'FAVOURITES_FOLDER_NOT_SELECTED';
export const FAVOURITES_FOLDER_SELECTOR_CLICKED_CLOSE_EVENT =
  'FAVOURITES_FOLDER_SELECTOR_CLICKED_CLOSE';
export const FAVOURITES_FOLDER_SELECTOR_CLICKED_VIEW_FAVOURITES_EVENT =
  'FAVOURITES_FOLDER_SELECTOR_CLICKED_VIEW_FAVOURITES';
